import styled from "styled-components";

export const Wrapper = styled.div`
    background-color: #131f28;
    border-radius: 20px;
    box-shadow: 0px 0px 15px 1px #00000066;

    .ant-form-item {
        margin-bottom: 10px;
    }
    .email-container {
        margin-top: 10px;
    }

    .form-container {
        padding: 30px 0px 40px;
    }
    .heading-conatiner {
        display: flex;
        justify-content: center;
    }
    .heading-conatiner {
        h1 {
            color: #fff;
            font-size: 25px;
            text-align: center;
        }
    }
    .form-details-conatiner {
        padding: 0px 60px;
    }
    .password-container {
        margin-top: 5px;
    }
    .login-button-conatiner {
        margin-top: 10px !important;
        .ant-btn {
            span {
                font-size: 14px;
            }
        }
    }
    .forget-password {
        margin-top: 5px;
        font-size: 15px;
        a {
            text-decoration: underline;
        }
    }
    @media screen and (max-width: 500px) {
        .heading-conatiner {
            h1 {
                font-size: 20px;
            }
        }
        .form-details-conatiner {
            padding: 0px 30px;
        }
    }
`;
